import React from 'react';
import { Group, Rect, Text } from 'react-konva';

const setCanvasCursor = (event, cursor) => {
  const container = event.target.getStage()?.container();
  if (container) container.style.cursor = cursor;
};

/**
 * DeleteButton component for AnnotationBlock
 */
export const DeleteButton = ({ width, onDelete }) => {
  return (
    <Group>
      <Rect
        x={width - 20}
        y={2}
        width={16}
        height={16}
        fill="#ff4444"
        cornerRadius={2}
        onClick={(e) => {
          e.cancelBubble = true;
          onDelete(e);
        }}
        onMouseEnter={() => {
          document.body.style.cursor = 'pointer';
        }}
        onMouseLeave={() => {
          document.body.style.cursor = 'default';
        }}
      />
      <Text
        x={width - 17}
        y={4}
        text="×"
        fontSize={14}
        fill="#fff"
        onClick={(e) => {
          e.cancelBubble = true;
          onDelete(e);
        }}
      />
    </Group>
  );
};

/**
 * ResizeHandle component for AnnotationBlock
 */
export const ResizeHandle = ({ width, height, onStartResize }) => {
  const hitWidth = Math.min(10, width);

  return (
    <>
      {/* Left handle */}
      <Rect
        name="resize-handle"
        x={0}
        y={0}
        width={hitWidth}
        height={height}
        fill="transparent"
        listening={true}
        onMouseOver={(e) => setCanvasCursor(e, 'ew-resize')}
        onMouseEnter={(e) => setCanvasCursor(e, 'ew-resize')}
        onMouseLeave={(e) => setCanvasCursor(e, 'default')}
        onMouseDown={(e) => {
          e.cancelBubble = true;
          onStartResize('left');
        }}
      />
      {/* Right handle */}
      <Rect
        name="resize-handle"
        x={Math.max(0, width - hitWidth)}
        y={0}
        width={hitWidth}
        height={height}
        fill="transparent"
        listening={true}
        onMouseOver={(e) => setCanvasCursor(e, 'ew-resize')}
        onMouseEnter={(e) => setCanvasCursor(e, 'ew-resize')}
        onMouseLeave={(e) => setCanvasCursor(e, 'default')}
        onMouseDown={(e) => {
          e.cancelBubble = true;
          onStartResize('right');
        }}
      />
    </>
  );
};
